import namespaceMd from "../../content/namespace.md?raw";
import { MarkdownDoc } from "../../components/MarkdownDoc";

/**
 * What a namespace is, shown before an applicant is asked to choose one.
 *
 * 🔑 WHY THIS EXISTS. The namespace IS the provider -- there is no separate
 * operator identifier anywhere on the platform, and every containment check
 * trusts it. Applicants routinely do not know that, so names arrive arbitrary
 * and a human reviews them by hand, which is the manual step blocking automatic
 * onboarding. Explaining the tree at the moment of choosing is far cheaper than
 * correcting a name that is already permanent.
 *
 * ⚠️ THE RULES BELOW ARE THE ONES THE CODE ENFORCES, not a paraphrase. The shape
 * is NAMESPACE_RE in domain/operator.ts. The containment behaviour -- subtree
 * yes, ancestor no, dot-bounded -- is from radius-wiki
 * `ankhos-operator-subscription-model.md`, which pins it to
 * `radbilling.go/app/model/containment_test.go:23`. If either changes this
 * document is wrong, and it will have misled someone into a permanent name.
 *
 * 🔑 Written as markdown and rendered through MarkdownDoc, so it reads as a
 * document and can be revised without touching a component.
 */
export function NamespaceGuide() {
  return <MarkdownDoc md={namespaceMd} />;
}
